"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchProductSubscription = exports.getActiveSubscriptions = exports.getActiveEntitlement = exports.getActiveSubscriptionWeb = exports.getActiveSubscription = exports.syncSubscription = exports.manageProducts = exports.getScheduledSubscription = exports.purchaseProduct = exports.getStorePrices = exports.getStorePrice = exports.getStoreProduct = exports.getAllStoreProducts = void 0;
const react_native_purchases_1 = __importDefault(require("react-native-purchases"));
const stripe_1 = __importDefault(require("stripe"));
const subscription_1 = require("../services/subscription");
const subscription_2 = require("../helper/subscription");
const constants_1 = require("./constants");
require("../polyfills/object");
const DOMAIN = `${window.location.protocol}//${window.location.host}`;
const NO_CANCELATION_PORTAL_CONFIG = {
    business_profile: {
        headline: null,
    },
    features: {
        customer_update: {
            enabled: true,
            allowed_updates: [
                'name',
                'email',
                'address',
            ]
        },
        invoice_history: {
            enabled: true,
        },
        payment_method_update: {
            enabled: true,
        },
    },
};
const stripe = new stripe_1.default('sk_test_51NNqPHLtdeH6HOYXphe1HEsSbz6wvlGKW4tBAagUYFe7yMUzhAZQ9EYDv1WC1pAyE95FEhohi74H893Vmy4LvWyT00oQqaE3t9');
const getAllStoreProducts = async (plans, force) => {
    try {
        const plansParam = plans || (force ? [] : constants_1.SUBSCRIPTION_PLANS);
        const productsList = await react_native_purchases_1.default.getProducts(plansParam || []);
        console.log('productsList: force:-', force, productsList);
        // const offerings = await Purchases.getOfferings(
        // );
        // console.log('offerings: -',offerings)
        // return hardcoded product list if we have issue from selections
        //@todo: After we are able to get Live products weneed to remove this.
        if (productsList.length < 2) {
            try {
                const offerings = await react_native_purchases_1.default.getOfferings();
                if (offerings?.current && offerings?.current?.availablePackages?.length !== 0) {
                    const allProducts = [];
                    offerings.current.availablePackages?.map((purchasePackage) => {
                        if (force && plansParam?.length > 0 && plansParam?.find((prodId) => prodId === purchasePackage?.product?.identifier)) {
                            allProducts.push(purchasePackage?.product);
                        }
                        else if (!force) {
                            allProducts.push(purchasePackage?.product);
                        }
                    });
                    console.log("Available package products:", allProducts);
                    return allProducts;
                    // Display current offering with offerings.current
                }
            }
            catch (e) {
                console.log('ERROR:', e);
                return [];
            }
        }
        return productsList;
    }
    catch (e) {
        console.error(e);
        return [];
    }
};
exports.getAllStoreProducts = getAllStoreProducts;
const getStoreProduct = async (identifier) => {
    try {
        const productsList = await react_native_purchases_1.default.getProducts([identifier]);
        // return hardcoded product list if we have issue from selections
        //@todo: After we are able to get Live products weneed to remove this.
        if (!productsList.length) {
            console.log("Missing product from RC...");
            const allProducts = await (0, exports.getAllStoreProducts)();
            return allProducts?.find((product) => product.identifier === identifier);
        }
        else {
            console.log("Got product from RC...", productsList);
            return productsList[0];
        }
    }
    catch (e) {
        console.log("getStoreProduct error..", e);
    }
};
exports.getStoreProduct = getStoreProduct;
const getStorePrice = async (identifier) => {
    const price = await stripe.prices.list({
        lookup_keys: [identifier],
        expand: ['data.product'],
    });
    return price.data[0];
};
exports.getStorePrice = getStorePrice;
const getStorePrices = async (...identifiers) => {
    const price = await stripe.prices.list({
        lookup_keys: identifiers,
        expand: ['data.product'],
    });
    return price.data;
};
exports.getStorePrices = getStorePrices;
const getCustomerId = async (userId) => {
    const { subscriber: { subscriptions: userSubscriptions } } = await (0, subscription_1.getUserInfo)(userId);
    const someUserTransactionId = Object.values(userSubscriptions)[0]?.store_transaction_id;
    if (!someUserTransactionId) {
        return null;
    }
    const { subscription: someUserSubscriptionId } = await stripe.subscriptionItems.retrieve(someUserTransactionId);
    const { customer } = await stripe.subscriptions.retrieve(someUserSubscriptionId);
    return customer.toString();
};
const purchaseProduct = async (price, userId, customerEmail) => {
    const customer = await getCustomerId(userId) || undefined;
    const session = await stripe.checkout.sessions.create({
        billing_address_collection: 'auto',
        customer,
        customer_email: customer ? undefined : customerEmail,
        line_items: [
            {
                price: price.id,
                quantity: 1,
            },
        ],
        mode: 'subscription',
        success_url: `${DOMAIN}`,
        cancel_url: `${DOMAIN}`,
    });
    if (session.url) {
        window.location.href = session.url;
    }
    ;
};
exports.purchaseProduct = purchaseProduct;
const getScheduledSubscription = async (userId) => {
    const customer = await getCustomerId(userId);
    if (!customer) {
        return null;
    }
    return (await stripe.subscriptionSchedules.list({
        customer,
        scheduled: true,
    })).data[0];
};
exports.getScheduledSubscription = getScheduledSubscription;
const manageProducts = async (userId) => {
    let portalConfigurationId;
    const customer = await getCustomerId(userId);
    if (!customer) {
        return null;
    }
    const scheduledSubscription = (await stripe.subscriptionSchedules.list({
        customer,
        scheduled: true,
    })).data[0];
    if (scheduledSubscription) {
        const noCancelationPortalConfig = (await stripe.billingPortal.configurations.list()).data.find((config) => NO_CANCELATION_PORTAL_CONFIG.isContainedIn(config));
        console.log(noCancelationPortalConfig);
        if (noCancelationPortalConfig) {
            portalConfigurationId = noCancelationPortalConfig.id;
        }
        else {
            portalConfigurationId = (await stripe.billingPortal.configurations.create(NO_CANCELATION_PORTAL_CONFIG)).id;
        }
    }
    const session = await stripe.billingPortal.sessions.create({
        customer,
        return_url: DOMAIN,
        configuration: portalConfigurationId
    });
    window.location.href = session.url;
};
exports.manageProducts = manageProducts;
const syncSubscription = async (sessionId, userId) => {
    const session = await stripe.checkout.sessions.retrieve(sessionId);
    (0, subscription_1.syncSubscriptionChanges)(userId, session.subscription.toString());
    //     product_id: "your_product_id"
};
exports.syncSubscription = syncSubscription;
/**
 * const getActiveSubscription: () => Promise<PurchasesStoreProduct[] | null>
 * @returns
 */
const getActiveSubscription = async () => {
    try {
        const customerInfo = await (react_native_purchases_1.default.getCustomerInfo());
        console.log('customerInfo:', customerInfo);
        console.log('customerInfo.entitlements?.active:', customerInfo.entitlements?.active);
        if (customerInfo.entitlements?.active) {
            const enKeys = Object.keys(customerInfo.entitlements?.active);
            const activeEntitlement = customerInfo.entitlements?.active?.[enKeys[0]];
            console.log('activeEntitlement.identifier:', activeEntitlement.identifier);
            const activeProduct = await (0, exports.getAllStoreProducts)([activeEntitlement.identifier], true);
            return activeProduct?.[0];
        }
        else {
            if (customerInfo?.activeSubscriptions?.length > 0) {
                const allActivePlans = await (0, exports.getAllStoreProducts)(customerInfo?.activeSubscriptions, true);
                console.log('All active subscriptions:', customerInfo?.activeSubscriptions);
                console.log('All active plans:', allActivePlans);
                return allActivePlans?.length > 1
                    ? allActivePlans?.find((product) => product.identifier === constants_1.PREMIUM_ANNUALLY || product.identifier === constants_1.PREMIUM_ANNUALLY_ANDROID) // we got more then 1 subscriptions return annual subscription
                    : allActivePlans?.[0];
            }
        }
    }
    catch (e) {
        console.log("get products error");
    }
    return null;
};
exports.getActiveSubscription = getActiveSubscription;
const getActiveSubscriptionWeb = async (userId) => {
    try {
        const { subscriber: { entitlements } } = await (0, subscription_1.getUserInfo)(userId);
        const activeEntitlement = (0, subscription_2.takeActiveEntitlement)(entitlements);
        return activeEntitlement;
    }
    catch (e) {
        console.log("get products error");
    }
    return null;
};
exports.getActiveSubscriptionWeb = getActiveSubscriptionWeb;
const getActiveEntitlement = async () => {
    try {
        const customerInfo = await react_native_purchases_1.default.getCustomerInfo();
        if (customerInfo.entitlements?.active) {
            const enKeys = Object.keys(customerInfo.entitlements?.active);
            const activeEntitlement = customerInfo.entitlements?.active?.[enKeys[0]];
            return activeEntitlement;
        }
    }
    catch (e) {
        console.log("get products error");
    }
    return null;
};
exports.getActiveEntitlement = getActiveEntitlement;
/**
 * const getActiveSubscription: () => Promise<PurchasesStoreProduct[] | null>
 * @returns
 */
const getActiveSubscriptions = async () => {
    try {
        const customerInfo = await react_native_purchases_1.default.getCustomerInfo();
        console.log('customerInfo entitlements-:', customerInfo.entitlements?.active);
        if (customerInfo?.activeSubscriptions?.length > 0) {
            const allActivePlans = await (0, exports.getAllStoreProducts)(customerInfo?.activeSubscriptions, true);
            return allActivePlans;
        }
    }
    catch (e) {
        console.log("get products error");
    }
    return null;
};
exports.getActiveSubscriptions = getActiveSubscriptions;
const switchProductSubscription = async (userId, productIdentifier) => {
    const { subscriber: { subscriptions: userSubscriptions } } = await (0, subscription_1.getUserInfo)(userId);
    const activeSubscription = (0, subscription_2.takeActiveSubscription)(Object.values(userSubscriptions));
    if (!activeSubscription) {
        throw new Error('Found no subscription');
    }
    const { subscription: activeSubscriptionId } = await stripe.subscriptionItems.retrieve(activeSubscription.store_transaction_id);
    const { current_period_end: activeSubscriptionEnd, customer } = await stripe.subscriptions.retrieve(activeSubscriptionId);
    const { id: newPriceId } = await (0, exports.getStorePrice)(productIdentifier);
    await stripe.subscriptions.update(activeSubscriptionId, {
        cancel_at_period_end: true,
    });
    (0, subscription_1.syncSubscriptionChanges)(userId, activeSubscriptionId);
    return stripe.subscriptionSchedules.create({
        customer: customer.toString(),
        start_date: activeSubscriptionEnd,
        phases: [{
                items: [{
                        price: newPriceId,
                    }],
            }],
    });
};
exports.switchProductSubscription = switchProductSubscription;
